import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox, SelectControllerVertical } from "@components";
import { TableColumn } from "./TableColumn";

import { useBaseData } from "@hooks/useBaseData";
import { useLanguage } from "@hooks/useLanguage";

import {
  getConvertedPositionData,
  getConvertedUnitData,
} from "@helpers/baseDataConvert";

import { BASE_DATA } from "@constants/base-data";

const { DESIGNATIONS, WINGS } = BASE_DATA;

type PositionsTableProps = {
  handleQuery: (key: string, value: number | string) => void;
  isLoading?: boolean;
  positionsTreeData?: never[];
  query?: any;
};

export const PositionsTable = ({
  handleQuery,
  isLoading,
  positionsTreeData,
  query,
}: PositionsTableProps) => {
  const { data: designation } = useBaseData(DESIGNATIONS);
  const { data: wings } = useBaseData(WINGS);

  const { language } = useLanguage();

  const { t } = useTranslation();
  const { control, register, setValue } = useForm();

  return (
    <Table
      columns={TableColumn(t)}
      loading={isLoading}
      rows={positionsTreeData || []}
      header={{
        badge: {
          label: `${positionsTreeData?.length || 0}`,
          size: "sm",
          type: "primary",
        },
        title: t("POSITION_LIST_TREE.TABLE.HEADER"),
        buttons: [
          <SearchBox
            key="search"
            control={control}
            placeholder="POSITION_LIST_TREE.TABLE.SEARCH"
            handleQuery={handleQuery as any}
          />,
        ],
      }}
      headerExtension={{
        leftComponents: [
          <div className="row">
            <SelectControllerVertical
              control={control}
              label="PROMOTION_CANDIDATES.TABLE.FORM.UNIT"
              name="unitId"
              options={getConvertedUnitData(
                wings.filter((item: any) => item?.name !== "ACC"),
                language,
              )}
              register={register}
              setValue={setValue}
              isSearchable
              selectAction={(e) => {
                handleQuery("unitId", e);
              }}
              portal
              cols={3}
              withoutLabel
            />

            <SelectControllerVertical
              control={control}
              label="POSITION_LIST_TREE.TABLE.FILTER.ASSIGNED_EMPLOYEE"
              name="assigned"
              options={[
                {
                  label:
                    language === "bn"
                      ? "বরাদ্দকৃত কর্মচারী"
                      : "Assigned Employee",
                  value: "true",
                },
                {
                  label:
                    language === "bn"
                      ? "বরাদ্দকৃত কর্মচারী নয়"
                      : "Not Assigned Employee",
                  value: "false",
                },
              ]}
              register={register}
              setValue={setValue}
              isSearchable
              selectAction={(e) => {
                handleQuery("assigned", e);
              }}
              portal
              cols={3}
              withoutLabel
              disabled={query?.unitId ? false : true}
            />

            <SelectControllerVertical
              control={control}
              label="PROMOTION_CANDIDATES.TABLE.FORM.DESIGNATION"
              name="positionId"
              options={getConvertedPositionData(designation, language)}
              register={register}
              setValue={setValue}
              isSearchable
              selectAction={(e) => {
                handleQuery("positionId", e);
              }}
              portal
              cols={3}
              withoutLabel
              disabled={query?.unitId ? false : true}
            />
          </div>,
        ],
      }}
      {...(positionsTreeData &&
        positionsTreeData.length > 6 && {
          height: 500,
          isStickyHeader: true,
        })}
    />
  );
};
